import { useState, type ChangeEvent } from "react";
import { DebounceInput } from "react-debounce-input";

import { SearchIcon24 } from "@/components/icons";

import { IconWrapper, SearchBarWrapperDiv } from "./search-bar.styles";

interface SearchBarProps {
    disabled?: boolean;
    debounceTimeout: number;
    placeholder: string;
    value: string | null;
    onChange: (event: ChangeEvent<HTMLInputElement>) => void;
    width?: string;
    backgroundColor?: string;
    autofocus?: boolean;
}

const SearchBar = ({
    disabled = false,
    debounceTimeout = 400,
    placeholder,
    value,
    onChange,
    width,
    autofocus = false,
    backgroundColor,
    ...remainingProps
}: SearchBarProps) => {
    const [isFocused, setIsFocused] = useState(false);

    return (
        <SearchBarWrapperDiv
            width={width}
            backgroundColor={backgroundColor}
            focus={isFocused}
            {...remainingProps}
        >
            <IconWrapper>
                <SearchIcon24 width={24} height={24} />
            </IconWrapper>
            <DebounceInput
                disabled={disabled}
                debounceTimeout={debounceTimeout}
                value={value || ""}
                onChange={onChange}
                placeholder={placeholder}
                autoFocus={autofocus}
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
            />
        </SearchBarWrapperDiv>
    );
};

export default SearchBar;
